import { render, staticRenderFns } from "./PedidosListWFilters.vue?vue&type=template&id=51c3cf11&scoped=true&"
import script from "./PedidosListWFilters.vue?vue&type=script&lang=ts&"
export * from "./PedidosListWFilters.vue?vue&type=script&lang=ts&"
import style0 from "./PedidosListWFilters.vue?vue&type=style&index=0&id=51c3cf11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3cf11",
  null
  
)

export default component.exports